import type { CSSProperties } from 'react'
import { BRAND_NAME, BRAND_TAGLINE } from '../shared/brand'
import { useAuth } from '../shared/hooks/useAuth'
import { sanitizeUserFacingMessage } from '../shared/utils/userMessage'

/** Inline styles so the screen stays readable if Tailwind/CSS variables fail in MAX WebView. */
const shellStyle: CSSProperties = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '24px',
  boxSizing: 'border-box',
  background: 'linear-gradient(145deg, #4f46e5 0%, #db2777 55%, #f472b6 100%)',
}

const titleStyle: CSSProperties = {
  margin: 0,
  fontSize: 'clamp(1.75rem, 6vw, 2.75rem)',
  fontWeight: 800,
  color: '#ffffff',
  textShadow: '0 2px 12px rgba(0,0,0,0.25)',
  lineHeight: 1.2,
}

const subtitleStyle: CSSProperties = {
  marginTop: 12,
  fontSize: 'clamp(1rem, 4vw, 1.25rem)',
  fontWeight: 600,
  color: 'rgba(255,255,255,0.95)',
  textShadow: '0 1px 8px rgba(0,0,0,0.2)',
}

const mutedStyle: CSSProperties = {
  marginTop: 20,
  fontSize: 14,
  color: 'rgba(255,255,255,0.88)',
}

export function Splash() {
  const { isLoading, error, initialize } = useAuth()

  const handleRetry = () => {
    void initialize()
  }

  return (
    <div style={shellStyle}>
      <div style={{ textAlign: 'center', maxWidth: 360 }}>
        <h1 style={titleStyle}>{BRAND_NAME}</h1>
        <p style={subtitleStyle}>🐾 {BRAND_TAGLINE}</p>

        {error ? (
          <div style={{ marginTop: 32 }}>
            <p style={{ ...mutedStyle, marginTop: 0, color: '#fee2e2', fontWeight: 600 }}>
              Ошибка загрузки
            </p>
            <p
              style={{
                marginTop: 8,
                fontSize: 13,
                color: 'rgba(255,255,255,0.92)',
                wordBreak: 'break-word',
              }}
            >
              {sanitizeUserFacingMessage(error)}
            </p>
            <button
              type="button"
              onClick={handleRetry}
              disabled={isLoading}
              style={{
                marginTop: 20,
                padding: '12px 20px',
                borderRadius: 12,
                border: 'none',
                fontWeight: 600,
                cursor: isLoading ? 'wait' : 'pointer',
                opacity: isLoading ? 0.75 : 1,
                WebkitTapHighlightColor: 'transparent',
                touchAction: 'manipulation',
                background: 'rgba(255,255,255,0.25)',
                color: '#fff',
              }}
            >
              {isLoading ? 'Повторяем…' : 'Попробовать ещё раз'}
            </button>
          </div>
        ) : (
          <div style={{ marginTop: 32 }}>
            <div
              style={{
                margin: '0 auto',
                width: 36,
                height: 36,
                border: '3px solid rgba(255,255,255,0.35)',
                borderTopColor: '#fff',
                borderRadius: '50%',
                animation: 'tolkosvoi-spin 0.85s linear infinite',
              }}
            />
            <style>{`@keyframes tolkosvoi-spin { to { transform: rotate(360deg); } }`}</style>
            <p style={mutedStyle}>{isLoading ? 'Подключаемся...' : 'Почти готово...'}</p>
          </div>
        )}
      </div>
    </div>
  )
}
